import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { useModalContext } from "../../Reactportal/ModalContext";
import Reactportal from "../../Reactportal/Reactportal";
import PortalFooter from "../../Reactportal/PortalFooter";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { CompliancesMasterFields } from "./AddCompliancesMaster.config";
import { useSelector } from "react-redux";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { ErrorToast } from "../../ToastComponent/RectHotToast";

import {
  CREATE_COMPLIANCES_MASTER,
  EDIT_COMPLIANCES_MASTER,
  GET_COMPLIANCES_MASTER_ID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { convertToISO, IsoToDateWithoutTime, toISODateWithIST } from "../../../../CommonFunction/IsoDateTime";

const AddCompliancesMaster = ({ show, TypeOfPortal = "Add", submitType, ParentPortalCloseFunction = () => {} }) => {
  console.log("Received props:", {
    show,
    TypeOfPortal,
    submitType,
  });

  const Form_Key = "Compliances_Master";
  const { pushModal, popModal } = useModalContext();
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const fieldData = fieldDataRedux?.[Form_Key]?.Selected_Row;
  const formRef = useRef({});
  const [allFieldsData, setAllFieldsData] = useState();
  const [toggle, setToggle] = useState(show ? show : false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();

  //Q & M
  const [CreatingData, { loading: createComplianceLoading }] = useMutation(CREATE_COMPLIANCES_MASTER, {
    fetchPolicy: "network-only",
  });
  const [GetComplainceById, { loading: getComplianceByIdLoading }] = useLazyQuery(GET_COMPLIANCES_MASTER_ID, {
    fetchPolicy: "network-only",
  });
  const [EditingData, { loading: editComplianceLoading }] = useMutation(EDIT_COMPLIANCES_MASTER, {
    fetchPolicy: "network-only",
  });

  const FormKeyLoadingState = createComplianceLoading || getComplianceByIdLoading || editComplianceLoading;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    setSelectedRows(fieldDataRedux?.[Form_Key]?.Selected_Rows);
  }, [fieldDataRedux]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      console.log(fieldData);
      GetComplainceById({
        variables: {
          id: fieldData?._id,
        },
      }).then(({ data }) => {
        let compliancesData = { ...data?.getcompliancesMasterById };
        if (compliancesData.date) {
          compliancesData.date = IsoToDateWithoutTime(compliancesData.date);
        }
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: compliancesData,
          },
        });

        setAllFieldsData(compliancesData);
        updateValueForm(formRef, compliancesData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fieldData, GetComplainceById, TypeOfPortal, dispatch]);

  const { executeOperation } = useSubmitOperation();
  let formData = FormData;
  const operationType = TypeOfPortal;

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  console.log(variables);
  const MutationFunctions = {
    CreatingData,
    EditingData,
  };

  const submit = async (closeAction) => {
    formData.date = toISODateWithIST(formData.date);
    console.log(formData, "formData");
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);

    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,

        PageName: Form_Key,
      });

    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: closeFormFunction,
      resetFormDataFunction: setAllFieldsData,
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const closeFormFunction = () => {
    ParentPortalCloseFunction();
    setToggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add" ? () => Validate_handleSubmit(SaveAndCloseForAdd) : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
      loadingState={FormKeyLoadingState}
    />
  );

  return (
    <Reactportal
      FoooterContent={footerContent}
      open={toggle}
      onClose={closeFormFunction}
      TypeOfPortal={`${TypeOfPortal} Compliances Master`}
    >
      <div className="formContainer">
        {CompliancesMasterFields.map((section) => (
          <div key={section.id} className="FormSectionParent">
            <div className="sectionHeadings">{replaceUnderscore(section.name)}</div>
            <div className="FormSection insidecontainer">
              <FormInputSectionComponent
                inputfields={section.fields}
                Type={section.name}
                onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                onhandleFormikChange={HanldeChangeonForm}
                formkey={Form_Key}
                formRef={formRef}
              />
            </div>
          </div>
        ))}
      </div>
    </Reactportal>
  );
};

export default AddCompliancesMaster;
